// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__pVMKy","savePackageButton":"ClientWallet_savePackageButton__2FApe"};